import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const gsapHorizontalItemScroll = (function ($) {

    gsap.registerPlugin(ScrollTrigger);

    let $fixedContainer = gsap.utils.toArray(".js-gsap-horizontal-item-scroll-container");

    function init() {

        if ($fixedContainer) {

            ScrollTrigger.matchMedia({
                // large desktop
                // ignored the "and (prefers-reduced-motion: no-preference)" media query because the title must be scrolled
                "(min-width: 1366px)": function() {
                    // pinned element only on desktop
                    $fixedContainer.forEach(function(elem) {

                        let fixedElements = elem.querySelectorAll(".js-gsap-horizontal-item-scroll-item-1");

                        let tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: elem,
                                scrub: 1,
                                // pin: true,
                                start: "center 70%",
                                end: "+=60%",
                                // markers: true
                            }
                        });

                        tl.fromTo(fixedElements, {xPercent: 0}, {xPercent: -50});

                    })
                },
                // desktop
                // ignored the "and (prefers-reduced-motion: no-preference)" media query because the title must be scrolled
                "(min-width: 1024px) and (max-width: 1365.98px)": function() {
                    // pinned element only on desktop
                    $fixedContainer.forEach(function(elem) {

                        let fixedElements = elem.querySelectorAll(".js-gsap-horizontal-item-scroll-item-1");

                        let tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: elem,
                                scrub: 1,
                                // pin: true,
                                start: "60% 70%",
                                end: "+=50%",
                                // markers: true
                            }
                        });

                        tl.fromTo(fixedElements, {xPercent: 0}, {xPercent: -50});

                    })
                },
                // mobile
                // ignored the "and (prefers-reduced-motion: no-preference)" media query because the title must be scrolled
                "(max-width: 1023.98px)": function() {
                    $fixedContainer.forEach(function(elem) {

                        let fixedElements = elem.querySelectorAll(".js-gsap-horizontal-item-scroll-item-1");

                        let tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: elem,
                                scrub: 1,
                                // pin: true,
                                start: "bottom-=200 80%",
                                end: "+=50%",
                                // markers: true
                            }
                        });

                        tl.fromTo(fixedElements, {xPercent: 0}, {xPercent: -50});

                    })
                }
            })
        }

    }

    return {
        init: init
    }

})(jQuery);